module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('div', {
    staticClass: "nav-wrapper-box"
  }, _vm._l((_vm.nav), function(item) {
    return _c('router-link', {
      key: item.path,
      staticClass: "nav-wrapper-item",
      attrs: {
        "to": item.path,
        "tag": "span"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleView(item.path)
        }
      }
    }, [_c('span', {
      staticClass: "nav-wrapper-item--title"
    }, [_vm._v("\n        \t\t" + _vm._s(item.name) + "\n        \t\t"), (!!item.num) ? _c('i', {
      staticClass: "nav-wrapper-item--num"
    }, [_vm._v(_vm._s(_vm.getFirstValue(item.num)))]) : _vm._e()])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b1f3c040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/nav.vue
// module id = 854
// module chunks = 39